module.exports = __webpack_public_path__ + "img/charcoal.0d621527.png";